/**
 * Rubric used in contests with Custom Judging upgrade
 */
export interface ContestRubric {
  readonly id: number;
  readonly contestId: number;
  readonly sections:
    | readonly ContestRubricSection[]
    | readonly ContestRubricSectionRequest[];
  readonly timeStarted?: number;
  readonly timeEnded?: number;
}

export interface ContestRubricSection {
  readonly id: number;
  readonly title: string;
  readonly description: string | undefined;
  readonly maxScore: number;
  readonly items: readonly ContestRubricItem[];
}

export type ContestRubricScoreType = 'number' | 'boolean';

export interface ContestRubricItem {
  readonly id: number;
  readonly title: string;
  readonly description: string | undefined;
  readonly maxScore: number;
  readonly scoreType: ContestRubricScoreType;
  readonly commentRequired: boolean;
}

export interface ContestRubricSectionRequest {
  readonly title: string;
  readonly description: string | undefined;
  readonly maxScore: number;
  readonly items: readonly ContestRubricItemRequest[];
}

export interface ContestRubricItemRequest {
  readonly title: string;
  readonly description: string | undefined;
  readonly maxScore: number;
  readonly scoreType: ContestRubricScoreType;
  readonly commentRequired: boolean;
}

export function isContestRubricSectionArray(
  sections:
    | readonly ContestRubricSection[]
    | readonly ContestRubricSectionRequest[],
): sections is readonly ContestRubricSection[] {
  if (sections.length === 0) {
    return true;
  }
  return 'id' in sections[0];
}
